import { FunctionComponent } from 'react'

// Components
import Checkout from '../../components/checkout/checkout.component'
import Header from '../../components/header/header.components'

const CheckoutPage: FunctionComponent = () => {
  return (
    <>
      <Header />
      <Checkout />
    </>

  )
}

export default CheckoutPage
